import * as React from 'react';
import { ICircleGraphProps } from './ICircleGraph';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const COLORS = ['#449dac', 'transparent'];

const RADIAN = Math.PI / 180;
interface CustomLabel {
    cx: number;
    cy: number;
    midAngle: number;
    innerRadius: number;
    outerRadius: number;
    percent: number;
    index: number;
    name: string;
}
const renderCustomizedLabel = (label: CustomLabel) => {
    const radius = label.innerRadius + (label.outerRadius - label.innerRadius) * 0.5;
    const x = label.cx + radius * Math.cos(-label.midAngle * RADIAN);
    const y = label.cy + radius * Math.sin(-label.midAngle * RADIAN);

    return (
        <>
            {!!label && label.name !== '' && (
                <text x={x} y={y} fill='white' textAnchor={x > label.cx ? 'start' : 'end'} dominantBaseline='central'>
                    {`${label.percent * 100}%`}
                </text>
            )}
        </>
    );
};

const CircleGraph = (props: ICircleGraphProps) => {
    const data = [
        { name: 'Channel usage rate', value: props.channelUsageRate },
        { name: '', value: 100 - props.channelUsageRate },
    ];
    return (
        <ResponsiveContainer width='100%' height='100%'>
            <PieChart width={150} height={150}>
                <Pie data={data} cx='50%' cy='50%' labelLine={false} label={renderCustomizedLabel} stroke='transparent' outerRadius={60} dataKey='value' startAngle={90} endAngle={-270}>
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
};

export default CircleGraph;
